import React, { useState } from 'react';
import { Flex } from '@components/Flex';
import { Box } from '@components/Box';
import { Columns } from '@components/Columns';
import { registryPageData } from '@data-ts/pages/registry';
import { LazyLoadWrapper } from '@components/LazyLoadWrapper';
import { CTALink } from '@components/CTALink';
import {
  HoneymoonFundWrapper,
  StyledTextPairing,
  StyledSlider,
  StyledSlideTrack,
  StyledSlide,
  StyledPlaceholderCloudImage,
  StyledGetStartedButton,
} from './RegistryHoneymoonFundSection.styles';

export const RegistryHoneymoonFundSection: React.FC = () => {
  const sectionId = 'Registry_Honeymoon_Fund_Section';
  const huneymoonFundSection = registryPageData.honeymoonFundSection;
  const [isVisible, setIsVisible] = useState(false);
  return (
    <HoneymoonFundWrapper as={'section'} paddingTop={[10, 12]} paddingBottom={14} id={sectionId}>
      <LazyLoadWrapper beforeLoad={() => setIsVisible(true)} threshold={0}>
        <div />
      </LazyLoadWrapper>
      <Columns>
        <Columns.Column width="full">
          <Flex
            alignItems={'center'}
            flexDirection={'column'}
            style={{ maxWidth: 780, marginLeft: 'auto', marginRight: 'auto' }}
            marginBottom={[7, 7]}
          >
            <StyledTextPairing
              alignment={'center'}
              eyebrow={huneymoonFundSection.eyebrow}
              eyebrowTagName="h2"
              eyebrowColor="humanaDark4"
              eyebrowVariant="sectionEyeBrow24"
              title={huneymoonFundSection.title}
              titleTagName={'h2'}
              titleColor={'neutra6'}
              titleVariant={'hed56'}
              body={huneymoonFundSection.body}
              bodyColor={'neutra5'}
              bodyVariant={'featureCopy17'}
            />
          </Flex>
          <Flex alignItems="center" justifyContent="center">
            <Box marginRight={[7]}>
              <StyledGetStartedButton id="registryHoneymoonFundGetStartedBtn" variant="secondary" page={'registry'}>
                {huneymoonFundSection.getStarted}
              </StyledGetStartedButton>
            </Box>
            <Box>
              <CTALink
                id="registryHoneymoonFundLearnMoreBtn"
                hasChevron={true}
                aria-label="Honeymoon Registry"
                href={huneymoonFundSection.learnMoreLink}
              >
                {huneymoonFundSection.learnMore}
              </CTALink>
            </Box>
          </Flex>
        </Columns.Column>
      </Columns>
      <StyledSlider>
        <StyledSlideTrack>
          {huneymoonFundSection.productList.map((product, index) => {
            return (
              <StyledSlide key={index}>
                <StyledPlaceholderCloudImage
                  resizeWidth={600}
                  mobileResizeWidth={350}
                  src={product.image}
                  alt={product.alt}
                  isMainSrcShown={isVisible}
                />
              </StyledSlide>
            );
          })}
          {huneymoonFundSection.productList.map((product, index) => {
            return (
              <StyledSlide key={index}>
                <StyledPlaceholderCloudImage
                  resizeWidth={400}
                  mobileResizeWidth={250}
                  src={product.image}
                  alt={product.alt}
                  isMainSrcShown={isVisible}
                />
              </StyledSlide>
            );
          })}
        </StyledSlideTrack>
      </StyledSlider>
    </HoneymoonFundWrapper>
  );
};
